module.exports = __webpack_public_path__ + "static/media/Event-06.34e61cf2.svg";